import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { FormEntryAttachmentBulkTaskActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function FormEntryAttachmentBulkTask({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as FormEntryAttachmentBulkTaskActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  const statusText = activity.status === 'success' ? '成功' : '失败'

  return (
    <ItemWrapper notification={notification}>
      《{formInfo.formName}》附件打包{statusText}
    </ItemWrapper>
  )
}
